module.exports = __webpack_public_path__ + "static/media/goodEducation.34e8ec23.png";